import { graphql } from "../generated";

export const SUPPORT_TOKEN_QUERY = graphql(`
  query SupportToken {
    supportToken {
      token
    }
  }
`);
